import { Font, StyleSheet } from "@react-pdf/renderer";
const font = require("../../../../fonts/NotoSans-Regular.ttf");

export const borderColor = "rgb(216, 222, 228)";

Font.register({
  family: "Open Sans",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf",
    },
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf",
      fontWeight: 600,
    },
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-700.ttf",
      fontWeight: 700,
    },
  ],
});

Font.register({
  family: "Noto Sans",
  src: font?.default,
});

export const styles: any = StyleSheet.create({
  body: {
    paddingTop: 10,
    paddingBottom: 55,
    paddingHorizontal: 15,

  },
  heading: {
    fontFamily: "Open Sans",
    fontSize: "14px",
    fontWeight: 700,
    color: "#262a44",
    marginVertical: 8,
    marginHorizontal: 8,
  },
  title: {
    fontSize: 24,
    textAlign: "center",
  },
  author: {
    fontSize: 12,
    textAlign: "center",
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
  },
  text: {
    fontSize: "7px",
    color: "#262a44",
    textAlign: "left",
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 15,
    maxWidth: 100,
    maxHeight: 40,
  },
  qr_image: {
    maxWidth: 200,
    maxHeight: 80,
    marginRight: 10
  },
  sub_header_1: {
    fontSize: 12,
    // marginBottom: 5,
    width: "100%",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  sub_header: {
    fontFamily: "Open Sans",
    fontWeight: 700,
    fontSize: "8px",
    color: "#262a44",
  },
  sub_header_small: {
    fontFamily: "Open Sans",
    fontSize: "6px",
    color: "#262a44",
  },
  header_layout: {
    justifyContent: "space-between",
    flexDirection: "row",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 15,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  time: {
    position: "absolute",
    fontSize: 6,
    bottom: 3,
    // left: 0,
    right: 10,
    textAlign: "center",
    color: "grey",
  },
  container: {
    flexDirection: "row",
    borderBottomColor: borderColor,
    backgroundColor: "#EEF1F4",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    textAlign: "center",
    fontStyle: "bold",
    flexGrow: 1,
  },
  row: {
    flexDirection: "row",
    borderBottomColor: borderColor,
    borderBottomWidth: 1,
    alignItems: "center",
  },
  table_width: {
    fontSize: "8px",
    width: "10%",
    // jab igst k condition ayege tb 14% rahega ye
    height: "100%",
    textAlign: "left",
    color: "#262a44",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingLeft: 3,
    flexWrap: "wrap",
    paddingTop: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  table_header: {
    fontSize: "7px",
    fontFamily: "Open Sans",
    fontWeight: 700
  },
  no: {
    fontSize: "8px",
    width: "4%",
    height: "100%",
    color: "#262a44",
    textAlign: "left",
    paddingLeft: 3,
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingTop: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  description: {
    fontSize: "9px",
    //changed it from 8 to 7 due to more columns
    // width: "28%",
    height: "100%",
    color: "#262a44",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingLeft: 3,
    paddingTop: 1,
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "left",
  },
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 8,
    borderWidth: 1,
    borderColor: borderColor,
  },
  gstTableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    height: "100%",
    borderWidth: 1,
    borderColor: borderColor,
  },
  tableFooter: {
    fontSize: "8px",
    fontFamily: "Open Sans",
    color: "#262a44",
    fontWeight: 600,
    padding: "2px",
  },
  for: {
    fontSize: "8px",
    fontFamily: "Open Sans",
    color: "#262a44",
    fontWeight: 600,
    // padding: "2px",
  },
  flexCenter: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    flexWrap: "wrap",
  },
  currencyFont: {
    // marginRight:"10px",
    fontFamily: "Noto Sans",
    fontSize: "7px",
    color: "#262a44",
  },
  flexColumn: {
    flexDirection: "column",
  },
  qrCode: {
    maxWidth: 70,
    maxHeight: 70,
  },
  sub_header_without_bottom_margin: {
    fontSize: 12,
    marginBottom: 5,
    width: "100%",
    flexDirection: "row",
  },
  text_sub_header: {
    fontFamily: "Open Sans",
    fontWeight: 700,
    fontSize: 9,
    color: "#262a44",
    marginLeft: 5,
  },
  ras_pollypack_text_sub_header: {
    fontFamily: "Open Sans",
    fontWeight: 700,
    fontSize: 9,
    color: "#262a44",
  },
  ras_pollypack_text: {
    fontSize: 9,
    color: "#262a44",
    textAlign: "left",
  },
  batch_id: {
    fontSize: 8,
    width: "15%",
    height: "100%",
    color: "#262a44",
    textAlign: "left",
    paddingLeft: 3,
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingTop: 1,
    justifyContent: "center",
    alignItems: "center",
    // wordWrap: "break-word"
    flexWrap: "wrap",
  }
});
